/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import {SolflareWalletAdapter} from "@solana/wallet-adapter-wallets";

require('./bootstrap');

// window.Vue = require('vue').default;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */



// import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import BootstrapVue3 from 'bootstrap-vue-3'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css'
//
// Make BootstrapVue available throughout your project
// Vue.use(BootstrapVue3)
// Optionally install the BootstrapVue icon components plugin
// Vue.use(IconsPlugin)

// import Vue from 'vue'
import { createApp } from "vue";
import VueChartKick from 'vue-chartkick'
import {Chart} from 'chart.js'
import { Colors } from 'chart.js';
Chart.register(Colors);

import zoomPlugin from 'chartjs-plugin-zoom';
Chart.register(zoomPlugin);

Chart.defaults.elements.point.radius = 1;
Chart.defaults.elements.line.borderWidth = 5;
Chart.defaults.elements.bar.borderWidth = 10;
Chart.defaults.plugins.zoom.pan = {
        enabled: true,
        mode: 'x',
        // modifierKey: 'ctrl',
        threshold: 10,
    }
// Chart.defaults.plugins.zoom.zoom.drag.enabled = true;
Chart.defaults.plugins.zoom.zoom.wheel.enabled = true;
Chart.defaults.plugins.zoom.zoom.pinch.enabled = true;
Chart.defaults.plugins.zoom.zoom.mode = 'x'
console.log(Chart.defaults)

import 'chartkick/chart.js'

window.divergentColor = [
    '#9945ff',
    '#608aff',
    '#5cb7ff',
    '#9adaff',
    '#e9f6fb',
    '#b2f7ff',
    '#6bf8f5',
    '#10f7cf',
    '#608aff'
];
window.singleColor = [
    '#9945ff',
    '#b85efc',
    '#d078fb',
    '#e393fb',
    '#f3aefc',
    '#ffcaff'
]
window.palleteColor = [
    '#a527b3',
    '#d5069c',
    '#f50b80',
    '#ff3763',
    '#ff5e47',
    '#ff8329',
    '#ffa600',
]

// Analytics chart colors - for multi-series charts
window.chartColors = {
    // Primary series colors (8 distinct colors)
    series: [
        '#8b5cf6',  // Purple (primary)
        '#ec4899',  // Pink
        '#10f7cf',  // Cyan
        '#f59e0b',  // Amber
        '#3b82f6',  // Blue
        '#22c55e',  // Green
        '#ef4444',  // Red
        '#6366f1',  // Indigo
    ],
    // Semantic colors
    positive: '#22c55e',
    negative: '#ef4444',
    neutral: '#6b7280',
    // Fee breakdown
    feeBreakdown: ['#6366f1', '#8b5cf6', '#f97316'],  // Base, Priority, Jito
    // Jito comparison
    jito: '#f97316',
    regular: '#8b5cf6',
    // Success/fail
    success: '#22c55e',
    fail: '#ef4444',
}

Chartkick.options = {
    // colors: window.singleColor,
}
//
// window.chartGradient = function(context) {
//     const chart = context.chart;
//     const gradient = chart.ctx.createLinearGradient(0, 0, 0, chart.height);
//     window.palleteColor.forEach((color, index) => {
//         gradient.addColorStop(index / (window.palleteColor.length - 1), color);
//     });
//     return gradient;
// };

console.log(Chartkick.options)
// Vuetify
// import 'vuetify/styles'
// import { createVuetify } from 'vuetify'
// import * as components from 'vuetify/components'
// import * as directives from 'vuetify/directives'
//
// import { aliases, mdi } from 'vuetify/iconsets/mdi'
//
// const vuetify = createVuetify({
//     components,
//     directives,
//     icons: {
//         defaultSet: 'mdi',
//         aliases,
//         sets: {
//             mdi,
//         }
//     },
// })


import ElementPlus from 'element-plus'
import MetricCard from './components/MetricCard.vue'
import GradientChart from './components/GradientChart.vue'
import BlockMetricsChart from './components/BlockMetricsChart.vue'
import 'element-plus/dist/index.css'

import Vuetable from 'vue3-vuetable'
// import { configureCompat } from 'vue'

// default everything to Vue 3 behavior, and only enable compat
// for certain features
// configureCompat({ MODE: 2 })

const app =  createApp()

const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => {
    const kebabize = (str) => str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs) => (ofs ? "-" : "") + $.toLowerCase())
    let kebab = kebabize(key.split('/').pop().split('.')[0])
    console.log(key, kebab, files(key))
    app.component(kebab, files(key).default)
})

import * as ElementPlusIconsVue from '@element-plus/icons-vue'

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

// import { createInertiaApp } from '@inertiajs/inertia-vue3'

// add in our wallet adaptor
import SolanaWallets, {initWallet, useWallet} from "solana-wallets-vue";
import { MoongateWalletAdapter } from "@moongate/moongate-adapter";

// You can either import the default styles or create your own.
import "solana-wallets-vue/styles.css";

// import { WalletAdapterNetwork } from "@solana/wallet-adapter-base";

const walletOptions = {
    wallets: [
        new SolflareWalletAdapter(),
        new MoongateWalletAdapter(),
        // no need with walletconnect
    ],
    autoConnect: true,
};

// toasts

import moshaToast from 'mosha-vue-toastify'
import 'mosha-vue-toastify/dist/style.css'
import { voteStore } from './stores/voteStore'

window.voteStore = voteStore
voteStore.loadAllVoteCounts()
voteStore.loadAllProjectScores()

// --- Initialize Asset Card Dynamic Updates ---
require('./asset-card-updater.js');
// --- End Asset Card Updates ---

app.config.globalProperties.window = window
app.component('metric-card', MetricCard)
   .component('gradient-chart', GradientChart)
   .component('block-metrics-chart', BlockMetricsChart)
   .component('validator-performance-chart', require('./components/ValidatorPerformanceChart.vue').default)
   .use(VueChartKick, Chartkick.options)
    .use(moshaToast)
    .use(Vuetable)
    .use(BootstrapVue3)
    .use(ElementPlus)
    .use(SolanaWallets,walletOptions)
    .mount('#app')

// initWallet()
window.wallet = useWallet()

/*
createInertiaApp({
    resolve: name => require(`./Pages/${name}`),
    setup({ el, App, props, plugin }) {
        const app = createApp({ render: () => h(App, props) }).use(plugin).mount(el)
        // app.use(Chartkick.use(Chart)).use(BootstrapVue3)
        /!*files.keys().map(key => {
            const kebabize = (str) => str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs) => (ofs ? "-" : "") + $.toLowerCase())
            let kebab = kebabize(key.split('/').pop().split('.')[0])
            console.log(key, kebab, files(key))
            app.component(kebab, files(key).default)
        })*!/
        // app.mount(el)
        // return app
    },
})
*/
// Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */


// require('./horizontal-menu/horizontal-menu');
// require('./horizontal-menu/stiky');
$('.layout-setting').on("click", function(e) {
    if (document) {
        $('body').toggleClass('dark-mode');
    } else {
        $('body').removeClass('dark-mode');
        $('body').addClass('light-mode');
    }
});
const layout = localStorage.getItem('dark-mode')
if (layout == 'dark') $(document).ready(() => $('body').addClass('dark-mode'))
$('.light-layout').click(() => {
    localStorage.setItem('dark-mode','dark')
})
$('.dark-layout').click(() =>{
    localStorage.setItem('dark-mode','light')
})
